// GL-DEV-648 — prevent PII from leaking into the browser console on deployed builds.
//
// `react-scripts build` sets NODE_ENV=production for EVERY deployed environment
// (development, staging, production), so this silences the console on all of them.
// Local `npm run dev` runs with NODE_ENV=development and keeps full console output
// for debugging.
//
// All console methods are silenced (not just log/info/debug): most of our
// console.error/console.warn calls pass raw error objects, which can carry PII.
// Remote production error visibility should come from a dedicated error tracker
// (e.g. Sentry) in a separate ticket — not the browser console.
//
// Imported as the very first line of index.tsx so it runs before any other
// module's top-level code can log.
if (process.env.NODE_ENV === 'production') {
  const noop = (): void => undefined;
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
}

export {};
